import { render, staticRenderFns } from "./ShipmentDetail.vue?vue&type=template&id=1e8c1228&scoped=true"
import script from "./ShipmentDetail.vue?vue&type=script&lang=js"
export * from "./ShipmentDetail.vue?vue&type=script&lang=js"
import style0 from "./ShipmentDetail.vue?vue&type=style&index=0&id=1e8c1228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8c1228",
  null
  
)

export default component.exports